import { render } from "./LaporanKpiPegawaiDetail.vue?vue&type=template&id=1055582e&scoped=true"
import script from "./LaporanKpiPegawaiDetail.vue?vue&type=script&lang=js"
export * from "./LaporanKpiPegawaiDetail.vue?vue&type=script&lang=js"

import "./LaporanKpiPegawaiDetail.vue?vue&type=style&index=0&id=1055582e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1055582e"]])

export default __exports__